import status from "../../constants/actionStatus";

const userSupportTicketsReducer = (
    state = {
        tickets: {},
    },
    action = {}
) => {
    switch (action.type) {
    case "USER_TICKETS_REQUEST":
        return {
            status: status.PENDING,
            tickets: {},
        };
    case "USER_TICKETS_SUCCESS":
        return {
            status: status.SUCCESS,
            tickets: action.payload,
        };

    case "USER_TICKETS_FAILURE":
        return {
            status: status.ERROR,
            tickets: {},
        };
    default:
        return state;
    }
};

export default userSupportTicketsReducer;
